import { css } from '@emotion/core';
import { colorsPalette } from '../../../../styles/colors';
import { typography } from '../../../../styles/typography';
import { MediaQueries } from '../../../../styles/Grid';

export const headline = css(typography.effra28, {
  verticalAlign: 'top',
  lineHeight: '32px !important',
});

export const items = css({
  marginTop: 16,
  [MediaQueries.sm]: {
    marginBottom: '16px',
    display: 'inline-block',
  },
});

export const item = css({
  marginBottom: '8px',
  [MediaQueries.xl]: {
    marginBottom: '16px',
  },
  [MediaQueries.sm]: {
    marginBottom: '24px',
  },

  '&:last-child': {
    marginBottom: 0,
  },
});

export const ctalinktxt = css({
  lineHeight: '32px',
  borderBottom: `1px solid ${colorsPalette.hrcolor}`,
  [MediaQueries.lg]: {
    fontSize: '21px',
  },
  [MediaQueries.md]: {
    fontSize: '17px',
    lineHeight: '24px',
  },
  [MediaQueries.sm]: {
    borderBottom: `1px solid ${colorsPalette.hrcolor}`,
  },
});
export const link = css({
  verticalAlign: 'top',

  span: {
    verticalAlign: 'top',
  },
});

export const headlineTextCss = css(typography.effra28);

export const anchorCss = css({
  textDecoration: 'none',
});
export const subItemAnchorCss = css({
  borderBottom: `1px solid ${colorsPalette.hrcolor}`,
});
export const anchorLabel = css({ color: colorsPalette.black });
// export const anchorBigLabel = css({});
export const anchorSmallLabel = css({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '500',
  borderBottom: `1px solid ${colorsPalette.hrcolor}`,
  [MediaQueries.md]: {
    borderBottom: '0',
  },
});

export const phaseTxt = css({ color: colorsPalette.phasetxt });
export const phaseSmallTxt = css({
  fontSize: '14px',
  lineHeight: '24px',
});
export const phaseBigTxt = css({
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  [MediaQueries.md]: {
    display: 'block',
  },
});

export const subLevel = css({
  marginLeft: 8,
  marginTop: 16,
  [MediaQueries.sm]: {
    marginTop: '24px',
  },
  span: {
    fontWeight: '400',
    fontSize: 14,
  },
});
export const subLevel0 = css({
  li: { marginBottom: 8 },
});
export const subLevel1 = css({
  marginTop: '8px',
  marginBottom: '16px',

  li: { marginBottom: 8 },
});
export const subLevel2 = css({});

export const sitemapPageCss = css({});
export const sitemapPageHeadlineCss = css({});
export const sitemapPageItem = css({
  [MediaQueries.xl]: {
    marginBottom: '8px',
  },
});
